export enum RestType {
  POST = 'post',
  GET = 'get',
  PATCH = 'patch',
  DELETE = 'delete',
  PUT = 'put',
}

export interface TokenResponse {
  access_token: string;
  refresh_token: string;
}

export enum ApiBaseErrorType {
  NEEDS_TO_REFRESH_TOKEN = 'NEEDS_TO_REFRESH_TOKEN',
  NEEDS_TO_RESTART_APP = 'NEEDS_TO_RESTART_APP',
  DO_NOTHING = 'DO_NOTHING',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  MAX_REFRESHING_TIMES = 'MAX_REFRESHING_TIMES',
  IS_REFRESHING = 'IS_REFRESHING',
}
